module.exports = __webpack_public_path__ + "media/images/icons/delete-e86f5a76bd55a77a27fd3c40ee201a8e.svg";